// import logo from './logo.svg';
import './App.css';
// import LanguageChooser from './Components/LanguageChooser/LanguageChooser';
import { appContext } from './Context/appProvider';
import {
    Outlet
  } from "react-router-dom";
import Layout from './Layout';
import { useContext } from 'react';
import Signin from './Pages/Signin/Signin';
import BecomeSeller, { Terms } from './Components/BecomeSeller';
import PendingApproval from './Components/PendingApproval';

function Root() {
    const { token, user, showTerms, setShowTerms } = useContext(appContext)
    return !token ? <Signin /> : !user?.userStatus ? (
        <BecomeSeller />
    ) : user?.userStatus == 5 ? <BecomeSeller rejected /> :  ['1', '3'].includes(user?.userStatus) ? (
        <PendingApproval />
    ) : (
        <Layout>
            <Outlet />
            {showTerms && <Terms show={setShowTerms} />}
        </Layout>
    )
}

export default Root;